const ReviewAutomation = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-purple-50 to-pink-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900">
              Send Automated Review Requests
            </h2>
            
            <p className="text-xl text-gray-600 leading-relaxed">
              ReceptionGenie automatically sends review requests after each job, helping you build a stellar online reputation effortlessly.
            </p>
            
            <div className="space-y-4">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-yellow-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-star-line text-yellow-600 text-2xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 text-lg mb-2">Automatic Timing</h3>
                  <p className="text-gray-600">Sends requests at the perfect moment when customers are most satisfied.</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-message-3-line text-green-600 text-2xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 text-lg mb-2">Personalized Messages</h3>
                  <p className="text-gray-600">Each request is customized with the customer's name and service details.</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-reply-line text-blue-600 text-2xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 text-lg mb-2">Auto-Response to Reviews</h3>
                  <p className="text-gray-600">Genie can automatically reply to reviews to keep customers engaged.</p>
                </div>
              </div>
            </div>
            
            <div className="bg-white rounded-2xl p-6 shadow-lg">
              <div className="flex items-center justify-between mb-4">
                <div className="text-sm font-semibold text-gray-500">Review Growth</div>
                <div className="text-2xl font-bold text-green-600">+47%</div>
              </div>
              <div className="flex items-center gap-2 mb-2">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i key={star} className="ri-star-fill text-yellow-400 text-2xl"></i>
                ))}
              </div>
              <div className="text-sm text-gray-600">Average rating increased to 4.9 stars</div>
            </div>
          </div>
          
          {/* Right Visual */}
          <div className="space-y-6">
            <div className="bg-white rounded-2xl p-6 shadow-xl">
              <div className="flex items-center gap-3 mb-4">
                <img 
                  src="https://static.readdy.ai/image/f188085399ab07ac2c79984c802b33af/d7137dec17d438e55dac1175e416585f.png" 
                  alt="Genie" 
                  className="w-12 h-12"
                />
                <div>
                  <div className="font-bold text-gray-900">ReceptionGenie</div>
                  <div className="text-sm text-gray-500">Automated Message</div>
                </div>
              </div>
              
              <div className="bg-gradient-to-r from-pink-50 to-purple-50 rounded-xl p-4 mb-4">
                <p className="text-gray-800 mb-3">
                  Hi Sarah! 👋
                </p>
                <p className="text-gray-800 mb-3">
                  Thank you for choosing our services! We hope you had a great experience with us.
                </p>
                <p className="text-gray-800 mb-4">
                  Would you mind taking a moment to share your feedback? Your review helps us serve you better!
                </p>
                <div className="flex gap-2">
                  <button className="whitespace-nowrap flex-1 px-4 py-2 bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-semibold rounded-lg transition-colors cursor-pointer text-sm">
                    <i className="ri-star-fill mr-1"></i>
                    Leave a Review
                  </button>
                </div>
              </div>
              
              <div className="text-xs text-gray-500 text-center">
                Sent automatically 2 hours after service completion
              </div>
            </div>
            
            <div className="bg-white rounded-2xl p-6 shadow-xl">
              <div className="flex items-center justify-between mb-4">
                <div className="font-bold text-gray-900">Recent Reviews</div>
                <div className="text-sm text-green-600 font-semibold">+12 this week</div>
              </div>
              
              <div className="space-y-3">
                {[
                  { name: 'Mike Chen', rating: 5, text: 'Excellent service! Very professional.' },
                  { name: 'Lisa Martinez', rating: 5, text: 'Quick response and great quality work.' },
                  { name: 'David Brown', rating: 5, text: 'Highly recommend! Will use again.' }
                ].map((review, index) => (
                  <div key={index} className="bg-gray-50 rounded-lg p-3">
                    <div className="flex items-center justify-between mb-2">
                      <div className="font-semibold text-gray-900 text-sm">{review.name}</div>
                      <div className="flex gap-0.5">
                        {[...Array(review.rating)].map((_, i) => (
                          <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                        ))}
                      </div>
                    </div>
                    <p className="text-xs text-gray-600">{review.text}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReviewAutomation;